<!--
  lovi
  忘记支付密码 2020-1-14
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('payPsd.forgotPayPsd')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />

    <div class="scroll-wrapper logReg-field">
      <scroll>
        <ul>
          <li>
            <van-cell-group>
              <van-field left-icon="icon-name" readonly v-model="username" />
            </van-cell-group>
          </li>
          <li>
            <van-cell-group>
              <van-field
                clearable
                left-icon="icon-lock"
                :right-icon="eye ? 'eye-o' : 'closed-eye'"
                @click-right-icon="eye = !eye"
                :type="eye ? 'text' : 'password'"
                v-model="password"
                :error="error.password ? true : false"
                @input="verifyPsd"
                :placeholder="$t('payPsd.loginPsd')"
              />
            </van-cell-group>
          </li>
          <li>
            <van-cell-group>
              <van-field
                class="van-field-phone"
                label="+63"
                left-icon="icon-tel"
                readonly
                v-model="phone"
              />
            </van-cell-group>
          </li>
          <li>
            <van-cell-group>
              <van-field
                class="van-field-code"
                clearable
                left-icon="icon-lock"
                v-model="code"
                :error="error.code ? true : false"
                @input="verifyCode"
                :placeholder="$t('common.enterVerificationCode')"
              >
                <div slot="button">
                  <van-count-down
                    class="text-orange"
                    v-if="countDownFlag"
                    :time="60000"
                    :format="$t('common.remaining') + 'ss s'"
                    @finish="finished"
                  />
                  <span v-else class="text-orange" @click="sendMobile">
                    {{
                      againFlag ? $t("common.getAgain") : $t("common.getItNow")
                    }}
                  </span>
                </div>
              </van-field>
            </van-cell-group>
          </li>
          <li>
            <van-button
              round
              type="primary"
              block
              :loading="btnLoading"
              @click="submit"
            >
              {{ $t("common.verification") }}
            </van-button>
          </li>
        </ul>
      </scroll>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as validate from "@/commonJs/validate.js";
export default {
  name: "forgetPayPsd",
  meta: {
    service: false // 客服
  },
  components: {},
  data() {
    return {
      username: "",
      password: "",
      phone: "",
      code: "",
      error: {
        password: false,
        code: false
      },
      eye: false,
      countDownFlag: false, // 倒计时
      againFlag: false, // 重新获取短信验证码
      btnLoading: false //按钮loadding
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    verifyPsd() {
      // 验证密码
      this.error.password = validate.validatePsd(this.password);
    },
    verifyCode() {
      // 验证码
      this.error.code = validate.validateCode(this.code);
    },
    finished() {
      // 倒计时结束
      this.countDownFlag = false;
      this.againFlag = true;
    },
    sendMobile() {
      // 获取手机验证码
      let vm = this;
      let params = {};
      params.phone = vm.phone.replace(/\s/g, "");
      params.type = 7;
      vm.$post("/app/captcha/sendMobile", params, {
        alert: true,
        loading: true
      }).then(res => {
        console.log("sendMobile", res);
        if (res.code == 0) {
          vm.countDownFlag = true;
        } else {
          vm.$toast(res.msg);
        }
      });
    },
    submit() {
      // 提交
      let vm = this;
      for (let key in vm.error) {
        if (vm.error[key]) {
          vm.$toast(vm.error[key]);
          return false;
        }
      }
      if (vm.password == "") {
        vm.$toast(vm.$t("common.enterPassword"));
        return false;
      }
      if (vm.code == "") {
        vm.$toast(vm.$t("common.enterVerificationCode"));
        return false;
      }
      let params = {};
      params.password = vm.password;
      params.phone = vm.phone.replace(/\s/g, "");
      params.code = vm.code;
      vm.btnLoading = true;
      // /app/captcha/validateCode
      vm.$post("/app/user/forgetPayPwd", params, { alert: true }).then(res => {
        vm.btnLoading = false;
        console.log("validateCode", res);
        if (res.code == 0) {
          // 设置支付密码
          vm.$router.replace({
            path: "/payPsd",
            name: "payPsd",
            query: { flag: "forget" },
            params: params
          });
        } else {
          vm.$toast(res.msg);
        }
      });
    }
  },
  watch: {
    userInfo: {
      handler(obj) {
        if (obj.username) {
          this.username = this.userInfo.username;
          this.phone = this._phoneFormat(this.userInfo.phone);
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped></style>
